<div class="trigger-dialog">
  <div class="dialog-close-btn" (click)="closeDialog()"></div>
  <div class="trigger-dialog-title">{{ 'sensor' | translate }} «{{ sensorName }}» <span class="lowercase">{{ 'detected_errors' | translate }}</span> </div>
  <div class="row fields-row">
    <div class="col-sm-12 table-box">
      <table class="table">
        <thead>
        <tr>
          <th>#</th>
          <th>{{ 'date' | translate }}</th>
          <th>{{ 'error_type' | translate }}</th>
          <th>{{ 'error_desc' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let w of warnings; let ind = index">
          <td>{{ ind +1 }}</td>
          <td>{{ w.chk_time | date:'short':'locale' }}</td>
          <td>{{ w.tr_type_name }}</td>
          <td>{{ w.tr_code_name }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-12">
      <div class="buttons-right dialog-buttons close-dialog">
        <button class="button-active" (click)="closeDialog()">
          {{ 'close'  | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

